import React from "react";
import NavbarManagement from "../../components/landing/Navbar";
import BannerHome from "../../components/landing/BannerHome";
import Footer from "../../components/landing/Footer";
import "../../styles/Background.css";
import "../../styles/fonts/_fontsize.css";
import "../../styles/sizes/_widths.css";
import "../../styles/animations.css";
import "../../styles/Cards.css";
import "../../styles/Buttons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import TwinexaBenefits from "../../components/landing/TwinexaBenefits";
import EcosistemaSection from "../../components/landing/EcosistemaSection";
import HowWeWork from "../../components/landing/HowWeWork";
import ClientsStrip from "../../components/landing/ClientsStrip";
import VSLSection from "../../components/landing/VSLSection";
import FAQ from "../../components/landing/FAQ";
import ProblemSection from "../../components/landing/ProblemSection";
import PositioningSection from "../../components/landing/PositioningSection";
import SegmentationSection from "../../components/landing/SegmentationSection";
import IndicatorsSection from "../../components/landing/IndicatorsSection";

const Home = () => {
  return (
    <div>
      <NavbarManagement />

      {/* 1. HERO */}
      <BannerHome />

      {/* 2. PROBLEMA */}
      <ProblemSection />
      <hr className="hr-white container" />

      {/* 3. POSICIONAMIENTO */}
      <PositioningSection />
      <hr className="hr-white container" />

      {/* 4. SEGMENTACIÓN TEMPRANA */}
      <SegmentationSection />
      <hr className="hr-white container" />

      {/* 6. DETALLE DE SOLUCIONES + INDICADORES */}
      <EcosistemaSection />
      <hr className="hr-white container" />

      {/* 7. CÓMO TRABAJAMOS */}
      <HowWeWork />
      <hr className="hr-white container" />

      {/* 8. INDICADORES 4.0 */}
      <IndicatorsSection />
      <hr className="hr-white container" />

      {/* 9. CLIENTES */}
      <TwinexaBenefits />
      <hr className="hr-white container" />
      <ClientsStrip />
      <hr className="hr-white container" />

      {/* 9. VSL + FORM */}
      <VSLSection />
      <hr className="hr-white container" />

      {/* 10. FAQ */}
      <FAQ />

      <Footer />
    </div>
  );
};

export default Home;
